module.exports = __webpack_public_path__ + "static/media/heart10.5e03bf3b.svg";